/**
 * Vendor Bills actions
 */
import Constants from '../../constants';

const { VendorBills, VendorBill } = Constants;

/**
 * Action object dispatched to get vendor bills
 *
 * @param {string} userId the user id
 * @param {object} params query params
 */
const getVendorBills = (userId, params) => ({
  type: VendorBills.GET_VENDOR_BILLS,
  userId,
  params,
});

/**
 * Action object dispatched when fetching vendor bills errors
 *
 * @param {object} error error object
 */
const getVendorBillsError = (error) => ({
  type: VendorBills.GET_VENDOR_BILLS_ERROR,
  error,
});

/**
 * Action object dispatched when fetching vendor bills succeeds
 *
 *  @param {object} action:
 *  {
 *    @property {string} count: total count of vendor bills that match the request query
 *    @property {object} vendorBills: all fetched vendor bills
 *  }
 */
const getVendorBillsSuccess = ({ count, vendorBills }) => ({
  type: VendorBills.GET_VENDOR_BILLS_SUCCESS,
  count,
  vendorBills,
});

/**
 * Action object dispatched to get vendor bills export
 *
 * @param {string} userId the user id
 */
const getVendorBillsExport = (userId) => ({
  type: VendorBills.GET_VENDOR_BILLS_EXPORT,
  userId,
});

/**
 * Action object dispatched when fetching vendor bills export errors
 *
 * @param {object} error error object
 */
const getVendorBillsExportError = (error) => ({
  type: VendorBills.GET_VENDOR_BILLS_EXPORT_ERROR,
  error,
});

/**
 * Action object dispatched when fetching vendor bills export succeeds
 *
 *  @param {object} action:
 *  {
 *    @property {object} vendorBills: all fetched vendor bills
 *  }
 */
const getVendorBillsExportSuccess = (vendorBills) => ({
  type: VendorBills.GET_VENDOR_BILLS_EXPORT_SUCCESS,
  vendorBills,
});

/**
 * Action object dispatched when fetching a vendor bill
 * @param {number} userId
 * @param {number} vendorBillId
 */
const getVendorBill = (userId, vendorBillId) => ({
  type: VendorBill.GET_VENDOR_BILL,
  userId,
  vendorBillId,
});

/**
 * Action object dispatched when an error occurs when fetching a vendor
 * bill
 * @param {object} error
 */
const getVendorBillError = (error) => ({
  type: VendorBill.GET_VENDOR_BILL_ERROR,
  error,
});

/**
 * Action object dispatched when the vendor bill is successfully fetched
 * @param {object} vendorBill
 */
const getVendorBillSuccess = ({ vendorBill }) => ({
  type: VendorBill.GET_VENDOR_BILL_SUCCESS,
  vendorBill,
});

export default {
  getVendorBills,
  getVendorBillsError,
  getVendorBillsSuccess,
  getVendorBillsExport,
  getVendorBillsExportError,
  getVendorBillsExportSuccess,
  getVendorBill,
  getVendorBillError,
  getVendorBillSuccess,
};
